import { render, staticRenderFns } from "./TabMaterials.vue?vue&type=template&id=56ce5c7f"
import script from "./TabMaterials.vue?vue&type=script&setup=true&lang=js"
export * from "./TabMaterials.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports